import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {DtoWorkhourOverview} from "./models/DtoWorkhourOverview";
import {DtoWorkhourOverviewFilter} from "./models/DtoWorkhourOverviewFilter";
import {AzureApiService} from "../../services/azure-api.service";

@Injectable()
export class EmployeeHouroverviewService {
    constructor(private http: AzureApiService) {
    }

    public getOverview = (filter: DtoWorkhourOverviewFilter): Observable<DtoWorkhourOverview[]> => {
        return this.http.post<DtoWorkhourOverview[]>('timesheet/overview', filter);
    };
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/employees/employee-houroverview/employee-houroverview.service.ts